import { render, staticRenderFns } from "./ProtectedAreasLayer.vue?vue&type=template&id=0ae5a470&scoped=true"
import script from "./ProtectedAreasLayer.vue?vue&type=script&lang=js"
export * from "./ProtectedAreasLayer.vue?vue&type=script&lang=js"
import style0 from "./ProtectedAreasLayer.vue?vue&type=style&index=0&id=0ae5a470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5a470",
  null
  
)

export default component.exports